
import React from 'react';

import Close from '@material-ui/icons/Close';
import CircularProgress from '@material-ui/core/CircularProgress';

/* Helper function */
function download_file(fileURL, fileName) {
    // for non-IE
    if (!window.ActiveXObject) {
        var save = document.createElement('a');
        save.download = fileName;
        save.href = fileURL;
        save.target = '_blank';

        if (
            navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) &&
            navigator.userAgent.search('Chrome') < 0
        ) {
            document.location = save.href;
            console.log(save.download);
        } else {
            var evt = new MouseEvent('click', {
                view: window,
                bubbles: true,
                cancelable: false,
            });
            save.dispatchEvent(evt);
            (window.URL || window.webkitURL).revokeObjectURL(save.href);
        }
    } else if (!!window.ActiveXObject && document.execCommand) {
        // for IE < 11
        var _window = window.open(fileURL, '_blank');
        _window.document.close();
        _window.document.execCommand('SaveAs', true, fileName || fileURL);
        _window.close();
    }
}

class ProtectedImg extends React.Component {

    state = {
        src: undefined,
        id: undefined,
        visible: true,
        isLoading: true
    };


    static getDerivedStateFromProps(props, state) {
        if (props.src !== state.src || props.id !== state.id) {
            state.src = props.src;
            state.id = props.id;
            return state;
        }
        return null;
    }

    handleDownload = (event) => {
        console.log(this.props.download);
        console.log(this.props.name);
        download_file(this.props.download, this.props.name);
    };

    handleDelete = (event) => {
        if (this.props.communication) {
            this.props.deleteCommunicationAttached(this.props.parent, this.state.id)
                .then(() => {
                    this.setState({ visible: false });
                })
                .catch((error) => {
                    console.log(error);
                    this.props.showError(error.message, error.type);
                })
        } else {
            this.props.deleteMessageAttached(this.props.parent, this.state.id)
                .then(() => {
                    this.setState({ visible: false });
                })
                .catch((error) => {
                    console.log(error);
                    this.props.showError(error.message, error.type);
                })
        }
    }

    handleImageLoaded = () => {
        this.setState({ isLoading: false });
    }

    handleImageErrored = () => {
        this.setState({ isLoading: false });
    }

    render() {
        const { src, id, visible, isLoading } = this.state;
        if (!visible) return <div />;
        return (
            <div className="flex_auto_row align_center">
                <div className="flex_auto_column min-miniatura " >
                    {this.props.edit &&
                        <Close className="miniatura-delete c_white bg_lipstick" onClick={this.handleDelete} />
                    }
                    {isLoading &&
                        <div className="upload-btn-wrapper margin_top_9 hand btn-loading">
                            <CircularProgress size={64} className={'fabProgress64 c_bluish'} />
                        </div>
                    }

                    <img className="preview hand margin_right_6 margin_left_6"
                        src={src}
                        alt={id}
                        height="64"
                        width="64"
                        id={`thumbnail-${id}`}
                        onClick={this.handleDownload}
                        onLoad={this.handleImageLoaded.bind(this)}
                        onError={this.handleImageErrored.bind(this)}
                    />

                </div>
                <span className="c_bluish barlow_italic_medium">{decodeURIComponent(this.props.name)}</span>
            </div>


        )
    }
}

export default ProtectedImg;


// WEBPACK FOOTER //
// ./src/components/complex/communications/ProtectedImg.js